var map = {
	"./aa.json": 9890,
	"./ab.json": 2819,
	"./ar.json": 3933,
	"./az.json": 293,
	"./bm.json": 1141,
	"./br.json": 4612,
	"./ca.json": 553,
	"./ch.json": 5305,
	"./de-CH.json": 2150,
	"./de.json": 8471,
	"./el.json": 7478,
	"./en-CA.json": 5598,
	"./en.json": 2007,
	"./es.json": 6905,
	"./et-EE.json": 525,
	"./fa.json": 9931,
	"./fi.json": 8919,
	"./fil.json": 9222,
	"./fr-CA.json": 4932,
	"./fr.json": 6863,
	"./he.json": 8208,
	"./hi.json": 3777,
	"./hu.json": 3426,
	"./id.json": 998,
	"./it.json": 5866,
	"./ja.json": 7203,
	"./ko.json": 6601,
	"./kr.json": 92,
	"./lt.json": 1202,
	"./mk-MK.json": 5187,
	"./ms.json": 161,
	"./nl-NL.json": 7974,
	"./nl.json": 8391,
	"./no.json": 1950,
	"./pa.json": 5082,
	"./pl.json": 6998,
	"./pt-BR.json": 9063,
	"./pt-PT.json": 3539,
	"./ro.json": 6575,
	"./ru.json": 2182,
	"./se.json": 8868,
	"./si.json": 1860,
	"./sk.json": 9549,
	"./sl.json": 8551,
	"./sv.json": 2524,
	"./sw.json": 971,
	"./th.json": 6170,
	"./tr.json": 5568,
	"./uk.json": 4994,
	"./vi.json": 9090,
	"./zh-CN.json": 3267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;